const MenuApi = [
    {
      id: 1,
      image: "images/maggi.jpg",
      name: "Maggi",
      category: "breakfast",
      price: "12₹",
      description:
        "Maggi noodles are dried noodles fused with oil, and sold with a packet of flavorings. These noodles are usually eaten after being cooked in boiling water for 3 to 5 minutes or eaten straight from the packet. Just boil the water, add the tastemaker and noodles and your maggi is ready within 2 to 3 minutes.",
    },
  
    {
      id: 2,
      image: "images/allupakoida.jpg",
      name: "Aloo Pakora",
      category: "evening",
      price: "20₹",
      description:
        "Aloo Pakora (Potato Bajji) is a very popular Indian snack where thinly sliced potatoes are coated with a spiced chickpea flour batter and deep-fried until crispy. This 20 minutes snack is best enjoyed with green chutney and masala chai on the side. Try it!",
    },
    {
      id: 3,
      image: "images/corn.jpg",
      name: "Corn",
      category: "breakfast",
      price: "10₹",
      description:
        "The corn came out perfectly cooked and snappy. It was tender, bright yellow, and moist. It had a little bit of browning in the spots where it came in contact with the grill, but overall it remained bright yellow. The flavor, however, was a bit bland.",
    },
    {
      id: 4,
      image: "../images/chola.jpg",
      name: "Chola",
      category: "lunch",
      price: "50₹",
      description:
        "Chole is a Punjabi word for chickpeas and masala is a word for spices. So this dish is nothing but chickpeas cooked to perfection with various spices, onions, tomatoes and herbs. Chickpea is a legume that is relished all over India.",
    },
    {
      id: 5,
      image: "../images/pizza.jpg",
      name: "Pizza",
      category: "evening",
      price: "80₹",
      description:
        "Pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients, baked quickly—usually, in a commercial setting, using a wood-fired oven heated to a very high temperature—and served hot",
    },
    {
      id: 6,
      image: "../images/nonvegthali.jpg",
      name: "Non-Veg Thali",
      category: "dinner",
      price: "180₹",
      description:
        "A thali is a combination of various dishes put together to make a whole meal. An average non-vegetarian thali usually contains salad, rice, chappati and gravy or dry chicken/mutton/fish dish to go with it.",
    },
    {
      id: 7,
      image: "../images/sweet.JPG",
      name: "Sweets",
      category: "dinner",
      price: "60₹",
      description:
        "A good cake, as our experts put it, must look beautiful and taste divine. It must have a perfect balance of appearance, texture, and flavour. It must have nothing but the best and freshest ingredients, meticulously mixed in the right proportions and baked to flawless perfection.",
    },
    {
      id: 8,
      image: "../images/rajmarice.jpg",
      name: "Rajma Rice",
      category: "lunch",
      price: "60₹",
      description:
        "These are smaller in size than most Rajma grown in plains and have a slightly sweetish taste. The combination of Rajma and rice generally lists as a top favorite of North Indians and Nepalis. Rajma is prepared with onion, garlic and many spices in India, and it is one of the staple foods in Nepal.",
    },
    {
      id: 9,
      image: "../images/samosa.jpg",
      name: "Samosa",
      category: "evening",
      price: "10₹",
      description:
        "A samosa is a fried or baked pastry with a savory filling, including ingredients such as spiced potatoes, onions, and peas. It may take different forms, including triangular, cone, or half-moon shapes, depending on the region.",
    },
  ];
  
  export default MenuApi;
